import { Loader } from "@googlemaps/js-api-loader";
const googleMapsLoader = new Loader({
  /*client key*/
  apiKey: "AIzaSyDKOTQIMPdSHlRS5BHvQw8D4cpBKwc2wOY",

  /* digiMonk */
  // apiKey: "AIzaSyApnQJuvU6_Owo6EpMWsqJLnKidWujyXJU",
  libraries: ["places"],
});

export const placesLoaded = () =>
  typeof window !== "undefined" &&
  Boolean(window.google && window.google.maps && window.google.maps.places);

// js-api-loader 1.16 resolves load() once the Maps core is in, which can be
// before the Places library is. react-places-autocomplete throws on mount
// without Places, which takes the whole page down, so wait for Places itself
// before rendering it. Retries a few times; resolves false if Maps won't load.
export const loadPlaces = async (attempts = 3) => {
  for (let i = 0; i < attempts; i += 1) {
    try {
      await googleMapsLoader.load();
      await googleMapsLoader.importLibrary("places");
      if (placesLoaded()) return true;
    } catch (e) {
      // try again below
    }
    await new Promise((resolve) => setTimeout(resolve, 800 * (i + 1)));
  }
  return placesLoaded();
};

export default googleMapsLoader;
